import React, { useMemo } from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getHamsKey } from '../../../services/product-to-hams-key';
import { ModalEntryPoint } from '../shared/modal-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './entrypoint';
import { type PlanSelectionPageModalType } from './plan-selection-page-modal';

const MODAL_CONFIGS = {
	twc: {
		width: '968px',
		height: '808px',
	},
	'reverse-trial': {
		width: '990px',
		height: '771px',
	},
};

export function PlanSelectionPageModal({ type }: { type: PlanSelectionPageModalType }) {
	const { cloudId, product } = useEditionAwareness();

	const { width, height } = MODAL_CONFIGS[type];

	const entryPointParams = useMemo(
		() => ({
			cloudId,
			hamsProductKey: getHamsKey(product),
		}),
		[cloudId, product],
	);

	const entryPointProps = useMemo(() => ({ type }), [type]);

	const modalProps = useMemo(
		() => ({
			width,
			height,
			shouldScrollInViewport: false,
			shouldCloseOnEscape: true,
		}),
		[width, height],
	);

	return (
		<ModalEntryPoint
			entryPointProps={entryPointProps}
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			modalProps={modalProps}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
